import config from 'config'

import { getParameterByName } from '../../Utils'

/**
 * Returns the initial state of the session, created using the parameters in the url.
 * @type {{locale: string, partnerid: *|string, moneymode: *, demomode: boolean ,currency: *|string, rchistoryurl: *|null, rcinterval: *|number, rcelapsed: *|number, userid: null, remoteusername: null, channel: *|string, token: null, replayToken: null, sid: null, balance: number, betAmount: number, legalBets: null, restoreVersion: number, quickStopEnabled: boolean, isMobile: boolean, gameServerAPIendpointURL: string, tokenAPIEndpointURL: string, gameReplayServiceURL: string, immediatePayouts: boolean, mode: string, country: *|string, ticket: *, developerMode: *}}
 */
export default () => {
  const initialSessionState = {
    locale: '',
    loadedLocale: '',
    partnerid: getParameterByName('partnerid') || config.SERVER_CONFIG.DEFAULT_PARTNER_ID,
    moneymode: getParameterByName('moneymode'),
    demomode: getParameterByName('demomode') === "true",
    currency: getParameterByName('currency') || config.SERVER_CONFIG.DEFAULT_CURRENCY,
    rchistoryurl: getParameterByName('rchistoryurl') || null,
    rcinterval: getParameterByName('rcinterval') || 0,
    rcelapsed: getParameterByName('rcelapsed'),
    rcshowresult: getParameterByName('rcshowresult'),
    rcenable: getParameterByName('rcenable'),
    rciframeurl: getParameterByName('rciframeurl') ,
    fullscreen: getParameterByName('fullscreen'),
    fgo: getParameterByName('fgo'),

    // Received with token-ok
    userid: null,
    remoteusername: null,

    channel: getParameterByName('channel') || config.SERVER_CONFIG.DEFAULT_CHANNEL,

    // Received on login
    token: null,
    replayToken: null,
    sid: null,
    balance: 0,
    betAmount: 0,
    betLines: null,
    legalBets: null,
    restoreVersion: 0,
    quickStopEnabled: Boolean(config.GAME_CONFIG.quickStopEnabled),
    isMobile: false, // If GET.channel === mobile

    gameServerAPIendpointURL: config.SERVER_CONFIG.SERVER_URL,
    tokenAPIEndpointURL: config.SERVER_CONFIG.TOKEN_URL,
    gameReplayServiceURL: config.SERVER_CONFIG.REPLAY_URL,
    immediatePayouts: Boolean(config.GAME_CONFIG.immediatePayouts),

    mode: config.GAME_CONFIG.mode || 'dev',
    country: getParameterByName('country') || '',

    ticket: getParameterByName('ticket'),

    developerMode: getParameterByName('developerMode'),

    noFullscreen: getParameterByName('developerMode')
  }

  const clientid = getParameterByName('clientid')
  initialSessionState.clientid = clientid ? decodeURIComponent(clientid) :
    config.SERVER_CONFIG.DEFAULT_CLIENT_ID

  const homeurl = getParameterByName('homeurl')
  initialSessionState.homeurl = homeurl ? decodeURIComponent(homeurl) : null

  const loc = getParameterByName('lang') || getParameterByName('locale')
  if (loc && loc.length) {
    if (loc === 'nb_NO') {
      initialSessionState.locale = 'no_NO'
    } else {
      initialSessionState.locale = loc
    }
  } else
    initialSessionState.locale = config.SERVER_CONFIG.DEFAULT_LOCALE

  // TODO: Make it only available in Dev environment?
  let spinDelay = getParameterByName('spinDelay')
  if (spinDelay) {
    if (spinDelay === 'false') {
      spinDelay = 0
    } else if (spinDelay === 'true') {
      spinDelay = 3000
    } else {
      spinDelay = isNaN(spinDelay) ? config.JURISDICTION_CONFIG.spinDelay : Number(spinDelay)
    }
    config.JURISDICTION_CONFIG.spinDelay = spinDelay
  }

  const country = getParameterByName('country')
  if (country) {
    initialSessionState.country = country
  }

  const jurisdiction = getParameterByName('jurisdiction') || getParameterByName('market')
  if (jurisdiction) {
    initialSessionState.jurisdiction = jurisdiction
  }

  initialSessionState.isMobile = initialSessionState.channel === 'mobile'

  initialSessionState.iOS = !!navigator.userAgent.match(/iPad/i) || !!navigator.userAgent.match(/iPhone/i)
  initialSessionState.webkit = !!navigator.userAgent.match(/WebKit/i)

  initialSessionState.is_iOSSafari = getParameterByName('isiossafari') ||
    (initialSessionState.iOS && initialSessionState.webkit && !navigator.userAgent.match(/CriOS/i))

  if (initialSessionState.isMobile)
    initialSessionState.minFrameTime = config.GAME_CONFIG.mobileMinFrameTime || 0
  else
    initialSessionState.minFrameTime = config.GAME_CONFIG.minFrameTime || 0

  if (initialSessionState.isMobile)
    document.body.classList.add('mobile')

  return initialSessionState
}
